export default "__VITE_ASSET__CZzNyTAh__ 224w, __VITE_ASSET__DU5T6p9___ 448w";